<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.warehouseStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.warehouseStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_view') || '查看'"
          placement="top"
        >
          <i
            class="el-icon-view tool-btn"
            @click="
              $emit('openEditFormDialog', {
                type: 'detail',
                code: row.warehouseCode
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_edit') || '编辑'"
          placement="top"
          v-if="allow('M')"
        >
          <i
            class="el-icon-edit tool-btn"
            @click="
              $emit('openEditFormDialog', {
                type: 'edit',
                code: row.warehouseCode
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-show="row.warehouseStatus != 'N'"
          v-if="allow('D')"
        >
          <i
            class="el-icon-delete tool-btn"
            @click="del(row.warehouseCode)"
          ></i>
        </el-tooltip>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      default: null,
      type: Object
    },
    loading: {
      default: false
    },
    components: {}
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq'
        },
        {
          field: 'col-opt',
          title: this.$l('table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'left',
          fixed: 'left',
          width: 110,
          slots: {
            default: 'opt'
          }
        },
        {
          field: 'warehouseNo',
          headerAlign: 'center',
          align: 'left',
          minWidth: 100,
          title: this.$l('table_label_warehouse_no') || '库房编号',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'warehouseDescription',
          headerAlign: 'center',
          align: 'left',
          minWidth: 250,
          title: this.$l('table_label_warehouse_description') || '库房描述',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },

        {
          headerAlign: 'center',
          field: 'orgCode',
          align: 'left',
          minWidth: 200,
          title: this.$l('table_label_org_code') || '所属机构',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'warehouseStatusName',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          title: this.$l('table_label_warehouse_status') || '有效状态',
          slots: { default: 'status' },
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'createByName',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          title: this.$l('table_label_create_by') || '创建人',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'createDate',
          headerAlign: 'center',
          align: 'center',
          minWidth: 170,
          title: this.$l('table_label_create_date') || '创建时间',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'modifyByName',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          title: this.$l('table_label_modify_by') || '修改人',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'modifyDate',
          headerAlign: 'center',
          align: 'center',
          minWidth: 170,
          title: this.$l('table_label_modify_date') || '修改时间',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        }
      ]
    }
  },
  methods: {
    del(code) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.$api.masWarehouseDelApi({ warehouseCode: code }).then((res) => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || res.msg,
            type: 'success'
          })
          this.$emit('reload')
        })
      })
    }
  }
}
</script>
